import React, { useState } from 'react';
import { LINK_KEY } from '@techchange/pm-specs';
import PropTypes from 'prop-types';
import { EditorView } from 'prosemirror-view';
import ReactDOM from 'react-dom';
import { Popover, PopoverBody } from 'reactstrap';

import { updateNodeAttrs } from '../../core/commands';
import { imageViewPluginKey } from '../plugins/imageView';

import ImageLink from './ImageLink';
import ImageOptions from './ImageOptions';

import styles from './ImageToolbar.module.scss';

const propTypes = {

	/**
	 * The prosemirror editor view object.
	 */
	editorView: PropTypes.instanceOf(EditorView).isRequired,

};

const ImageToolbar = (props) => {

	const { editorView } = props;

	// Get image data from plugin state
	const { imageNode, imagePos } = imageViewPluginKey.getState(editorView.state);
	const imageDOM = editorView.nodeDOM(imagePos);

	// Check for link on image
	const linkMarkType = editorView.state.schema.marks[LINK_KEY];
	const linkMark = imageNode && imageNode.marks.find((mark) => mark.type === linkMarkType);

	const [showLinkInput, setShowLinkInput] = useState(false);

	const handleAttrsUpdate = (attrs) => {

		updateNodeAttrs(imageNode.attrs, attrs, imagePos)(editorView.state, editorView.dispatch);

	};

	const handleToggleLinkInput = () => {

		setShowLinkInput((prev) => !prev);

	};

	if (imageDOM && imageNode) {

		const position = imageNode?.attrs?.position;
		const size = imageNode?.attrs?.size;

		return (
			<Popover
				key={`${position}-${size}`} // Trigger re-mount if image moves
				className={styles['image-toolbar']}
				target={imageDOM}
				placement="top"
				modifiers={[{
					name: 'flip',
					enabled: false,
				}]}
				fade={false}
				hideArrow
				isOpen>
				<PopoverBody>
					{showLinkInput
						? (
							<ImageLink
								editorView={editorView}
								href={linkMark?.attrs?.href}
								onBack={handleToggleLinkInput} />
						) : (
							<ImageOptions
								size={imageNode.attrs.size}
								position={imageNode.attrs.position}
								link={linkMark}
								onAttrsUpdate={handleAttrsUpdate}
								onLinkClick={handleToggleLinkInput} />
						)
					}
				</PopoverBody>
			</Popover>
		);

	}

	return <div />;

};

ImageToolbar.propTypes = propTypes;

export default ImageToolbar;
